import React from 'react';
import { useHistory } from 'react-router';
import { Row, Col } from 'antd';
import { Item, DividerContainer, ButtonBackData } from '@BUP/components';
import Diagnostico from '@BUP/assets/Images/Data/data_diagnostico.png';
import Sociograma from '@BUP/assets/Images/Data/data_sociograma.png';
import QuienesResponden from '@BUP/assets/Images/Data/data_¿quienes-responden.png';
import Duracion from '@BUP/assets/Images/Data/data_¿duracion.png';
import QueMide from '@BUP/assets/Images/Data/data_¿que-mide.png';
import CuandoFinaliza from '@BUP/assets/Images/Data/data_¿cuando-finaliza.png';
import './styles.css';
import { useTranslation } from 'react-i18next';

const DataInstrumentsStudent = () => {
  const history = useHistory();
  const [t] = useTranslation();

  return (
    <>
      <ButtonBackData onClick={() => history.goBack()} />
      <DividerContainer title={t('pages.data.instruments.dividerText1')} />

      <p className="instrumentsStudent_paragraph">
        {t('pages.data.instruments.introText')}
      </p>
      <Row justify="space-around">
        <Col xs={24} sm={12} lg={8}>
          <Item
            src={Diagnostico}
            title={t('pages.data.instruments.diagnosticTitle')}
            description={t(
              'pages.data.instruments.diagnosticDescriptionStudent'
            )}
          />
        </Col>
        <Col xs={24} sm={12} lg={8}>
          <Item
            src={Sociograma}
            title={t('pages.data.instruments.sociogramTitle')}
            description={t(
              'pages.data.instruments.sociogramDescriptionStudent'
            )}
          />
        </Col>
      </Row>
      <DividerContainer title={t('pages.data.instruments.dividerText2')} />
      <Row justify="space-around">
        <Col xs={24} sm={12} lg={8}>
          <Item
            src={QuienesResponden}
            title={t('pages.data.instruments.whoAnswerTitle')}
            description={t(
              'pages.data.instruments.whoAnswerDescriptionStudent'
            )}
          />
        </Col>

        <Col xs={24} sm={12} lg={8}>
          <Item
            src={Duracion}
            title={t('pages.data.instruments.durationTitle')}
            description={t('pages.data.instruments.durationDescriptionStudent')}
          />
        </Col>

        <Col xs={24} sm={12} lg={8}>
          <Item
            src={QueMide}
            title={t('pages.data.instruments.whatMeasuresTitle')}
            description={t(
              'pages.data.instruments.whatMeasuresInstrumentDescriptionStudent'
            )}
          />
        </Col>

        <Col xs={24} sm={12} lg={8}>
          <Item
            src={CuandoFinaliza}
            title={t('pages.data.instruments.whenItEndsTitle')}
            description={t(
              'pages.data.instruments.whenItEndsDescriptionStudent'
            )}
          />
        </Col>
      </Row>

      <DividerContainer title={t('pages.data.instruments.dividerText3')} />

      <Row justify="space-around">
        <Col xs={24} sm={12} lg={8}>
          <Item
            src={QuienesResponden}
            title={t('pages.data.instruments.whoAnswerTitle')}
            description={t(
              'pages.data.instruments.whoCanANswerDescriptionStudent'
            )}
          />
        </Col>
        <Col xs={24} sm={12} lg={8}>
          <Item
            src={Duracion}
            title={t('pages.data.instruments.durationTitle')}
            description={t('pages.data.instruments.durationDescriptionStudent')}
          />
        </Col>
        <Col xs={24} sm={12} lg={8}>
          <Item
            src={QueMide}
            title={t('pages.data.instruments.whatMeasuresTitle')}
            description={t(
              'pages.data.instruments.whatMeasuresDescriptionStudent'
            )}
          />
        </Col>
        <Col span={24} align="start">
          <ButtonBackData onClick={() => history.goBack()} />
        </Col>
      </Row>
    </>
  );
};

export default DataInstrumentsStudent;
